'use strict'

function imageLoader(images) {
    function loader(imgSrc) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () { return resolve(imgSrc); };
            img.onerror = function (err) { return reject(err); };
            img.src = imgSrc;
        });
    }
    var loaders = [];
    for (var i = 0; i < images.length; i++) {
        var image = images[i];
        loaders.push(loader(image));
    }
    return Promise.all(loaders);
}

module.exports = imageLoader;
